<template>
  <div class="biddingHall_w">

    <div class="column-title  fz20 c_1A1A1A font_w_bold">
      交易大厅
    </div>

    <div class="position-relative">
      <ul class="tradeKind_w overflow_auto">
        <li
          class="tradeKind_i float_l fz14 c_1A1A1A cursor_pointer"
          :class="tradeKindIndex < 0 ? 'isActive' : ''"
          @click="onAllTradeKindClick"
        >
          全部
        </li>
        <li
          class="tradeKind_i float_l fz14 c_1A1A1A cursor_pointer"
          v-for="(item, index) in tradeModes"
          :key="item.key"
          @click="onTradeKindClick(item, index)"
          :class="tradeKindIndex === index ? 'isActive' : ''"
        >
          {{ item.value }}
        </li>

      </ul>
      <div class="more-btn" @click="onMoreClick">更多>></div>
    </div>

    <!-- 项目列表 -->
    <ProjectList :list="dynamicData.list">
      <template #inner>
        <TradeItem
          v-for="item in dynamicData.list"
          :key="item.id"
          :data="item"
          @click.native="onGoProjectItem(item.projectNo)"
        />
      </template>
    </ProjectList>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {  uuid } from "@/utils";
import { portal_project_tradingHall } from "@/api/portal";

import TradeItem from "@/components/template/otherTradeKind/TradeItem.vue";
import CardHead from "@/components/template/CardHead.vue";
import ProjectList from "@/components/template/ProjectList.vue";

export default {
  components: {
    TradeItem,
    CardHead,
    ProjectList,
  },
  data() {
    return {
      dynamicData: {}, // 竞拍大厅数据
      rows: 16, // 默认条数
      tradeKindIndex: -1,
      tradeMode: "",
    };
  },
  computed: {
    ...mapGetters(["siteInfo", "tradeModes"]),
  },
  watch: {
    tradeMode(n) {
      this.getBiddingHallData();
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.getBiddingHallData()
        }
      },
      immediate:true,
      deep:true,
    }
  },

  created() {
  },

  methods: {
    // 更多 click
    onMoreClick() {
      this.$router.push({
        name: "tradeHall",
      });
    },
    // 获取竞拍大厅数据 api
    async getBiddingHallData() {
      const { data } = await portal_project_tradingHall({
        rows: this.rows,
        uid: uuid(13),
        tradeMode: this.tradeMode,
      }); // 如果是动态变化的数据，必须设置uid，否则浏览器会缓存！
      if (!data) {
        this.dynamicData = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0,
        };
        return;
      }
      this.dynamicData = data;
    },

    // 交易品种项点击 click
    onTradeKindClick(item, index) {
      this.tradeKindIndex = index;
      this.tradeMode = item.key;
    },
    // 全部 click
    onAllTradeKindClick() {
      this.tradeKindIndex = -1;
      this.tradeMode = "";
    },

    //前往项目详情 click
    onGoProjectItem(projectNo) {
      this.$router.push({
        name: "tradeDetail",
        query: {
          projectNo,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.biddingHall_w {
  .tradeKind_w {
    margin: 10px 0;
  }
  .tradeKind_i {
    position: relative;
    height: 32px;
    line-height: 32px;
    padding: 0 27px;
    margin: 0 0 10px 0;
    // border-right: 1px solid #ccc;
    // border-radius: 32px;
    font-size: 16px;
    // &::after {
    //   content: "";
    //   position: absolute;
    //   width: 50px;
    //   height: 8px;
    //   bottom: 0;
    //   left: 27px;
    //   background-image: linear-gradient(to right, #0983cc, #8ab8f2);
    //   border-radius: 8px;
    // }
    &:last-child {
      border-right: none;
    }
  }
  .isActive {
    color: #0983cc;
    // border: 1px solid #3d9dd6;
    &.tradeKind_i {
      &::after {
        content: "";
        position: absolute;
        width: 60px;
        height: 2px;
        bottom: -2px;
        left: 0;
        right: 0;
        margin: auto;
        background-image: linear-gradient(to right, #0983cc, #8ab8f2);
        border-radius: 8px;
      }
    }
  }
  .more-btn{
    position: absolute;
    right:0;
    top: 5px;
    cursor: pointer;
  }
  .div_1 {
    margin: 20px 0;
  }

  .span_1 {
    width: 2px;
    height: 14px;
    margin: 0 4px;
    background: #0983cc;
  }
}
</style>
